import { NucToast } from "src/reusable/components/Toast";

/**
 * Surface an API failure instead of swallowing it: show the backend's
 * ``detail`` in the toast when present, falling back to a generic message
 * otherwise.
 */
/** The backend's ``detail`` string from an API error, if it sent one. */
export function getApiErrorDetail(err: unknown): string | undefined {
  const detail = (err as { response?: { data?: { detail?: unknown } } })
    ?.response?.data?.detail;
  return typeof detail === "string" && detail ? detail : undefined;
}

export function toastApiError(err: unknown, fallback: string) {
  NucToast({
    message: getApiErrorDetail(err) ?? fallback,
    type: "error",
    hideProgressBar: false,
  });
}
